<script setup lang="ts">
import InfoMessage from '@/components/InfoMessage/InfoMessage.vue';
import { upperFirst } from 'lodash';
import { computed, ref, StyleValue, useAttrs } from 'vue';
import type { FormLabelProps } from './types';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<FormLabelProps>(), {});
const passdownProps = computed(() => ({ ...props, label: undefined }));
const attrs = useAttrs();
const passdownAttrs = computed(() => ({
  ...attrs,
  class: undefined,
}));
const isHovering = ref(false);
const hasFocus = ref(false);
const onBlur = () => {
  hasFocus.value = false;
};

const onFocus = () => {
  hasFocus.value = true;
};

const style = attrs.style as StyleValue;
</script>

<template>
  <div :class="attrs.class" :style="style">
    <v-label
      v-if="label"
      v-bind="{ ...passdownProps, ...passdownAttrs }"
      :class="[
        'mb-1',
        'd-block',
        'text-wrap',
        (hasFocus || isHovering) && 'text-secondary',
        disabled && 'label-disabled',
      ]"
      >{{ upperFirst(label) }}<InfoMessage :value="infoMessage" size="16" />
    </v-label>
    <v-hover v-model="isHovering">
      <template #default="{ props: hoverProps }">
        <slot name="default" v-bind="{ onFocus, onBlur, hoverProps }" />
      </template>
    </v-hover>
  </div>
</template>

<style scoped lang="scss">
.label-disabled {
  opacity: 0.7;
  color: rgb(var(--v-theme-primary-lighten-3));
}
</style>
